module.exports = __webpack_public_path__ + "img/head-side-heart.f188ece7.svg";